import { Bounty } from './../../interfaces/Bounty';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.scss'],
})
export class PaymentCompleteComponent implements OnInit {
  public success: boolean;
  public bountyId: number;

  constructor(
    route: ActivatedRoute,
  ) {
    const { success, id } = route.snapshot.params;

    this.success = success === 'true';
    this.bountyId = id;
  }

  ngOnInit() {
  }

}
